import React from 'react'

class ScheduleTab extends React.Component {
  handleClick () {
    this.props.handleTabChange(this.props.tab)
  }

  render () {
    const {classname, icon, text } = this.props
    return (
      <td className={classname} onClick={() => this.handleClick()}>
        <div className='schedule-header-tabs'>
          <span>{text}</span>
          <span>
            <i className={icon}></i>
          </span>
        </div>
      </td>
    )
  }
}

export default ScheduleTab;